import React from 'react'
import {
	Notice
} from 'components/ui/reusable'
import strings from 'translations/ro.json'
const products = strings.sections.products

const Products = () => (
	<section className='products row' id='products'>
		<Notice
			className='col-lg-12'
			title={products.header.title}
			subtitle={products.header.subtitle} />

		<div className='left-container col-md-6 col-lg-6'>
			<img src={require('media/products.jpg')} alt={products.title}/>
		</div>

		<div className='right-container content-container col-md-6 col-lg-6'>
			<h2>{products.title}</h2>
			<p>{products.subtitle}</p>
			<a href='#contact'>{products.button}</a>
		</div>
	</section>
)

export default Products



// WEBPACK FOOTER //
// ./src/components/ui/sections/Products.js